import { defineStore } from "pinia";
import DataSource from "devextreme/data/data_source";
import { ref } from "vue";
import { useDukListModel } from "@/stores/models/duk-list-model";

export const useDukListStore = defineStore("dukListStore", () => {
  const isLoading = ref(false);
  const dataSourceDukList = ref(
    new DataSource({
      requireTotalCount: true,
      store: useDukListModel().dukListCustomStore,
      filter: null,
      skip: 0,
      take: null,
    }),
  );

  const dataSourceDukListGetData = ref(
    new DataSource({
      requireTotalCount: true,
      store: useDukListModel().dukListCustomStore,
      filter: null,
      skip: 0,
      take: null,
    }),
  );

  // const dataSourcePegawaiList = (additionalParams = null) => {
  //     console.log('masuk dataSourcePegawaiList', additionalParams)
  //     return new DataSource({
  //       requireTotalCount: true,
  //       load: (loadOptions) => {
  //         // Handle load options and additionalParams separately
  //         return usePegawaiListModel().pegawaiListCustomStore.load([loadOptions, additionalParams]);
  //       }
  //     });
  // };

  const getData = async (filter) => {
    useDukListModel().setFilter(filter);

    useDukListModel().setTake("all");
    await dataSourceDukListGetData.value.reload();
    // await  dataSourceDukList.value.reload();
    // return {
    //   data: dataSourceDukListGetData.value._items,
    //   totalCount: dataSourceDukListGetData.value._items.length,
    //   // summary: [totalBiaya]
    // };

    const result = {
      data: dataSourceDukListGetData.value._items,
      totalCount: dataSourceDukListGetData.value._items.length,
      // summary: [totalBiaya]
    };
    useDukListModel().setFilter(null); // reset filter
    return result;
  };

  const setFilter = (filter) => {
    useDukListModel().setFilter(filter);
    dataSourceDukList.value.reload();
  };

  const state = ref(true);
  const refresh = () => {
    dataSourceDukList.value.reload();
  };

  const onTglChanged = (e) => {
    const tgl = e.value; // You get the selected date here
    useDukListModel().setFilter(["tgl", "=", tgl]);
    dataSourceDukList.value.reload();
  };

  const onPegawaiStatusChanged = (e) => {
    useDukListModel().setFilter(["capeg_tetap", "=", e.value]);
    dataSourceDukList.value.reload();
  };

  const initialized = () => {
    // const currentDate = new Date();
    // const currentYear = currentDate.getFullYear();
    // const currentMonth = currentDate.getMonth() + 1; // Months are zero-based
    // const formattedDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-01`;
    useDukListModel().setFilter(null);
    dataSourceDukList.value.reload();
  };

  return {
    setFilter,
    onPegawaiStatusChanged,
    dataSourceDukList,
    isLoading,
    refresh,
    initialized,
    state,
    getData,
    onTglChanged,
  };
});
